export const ANSWER_LAG_TIME = {
  CORRECT: 500,
  INCORRECT: 2000
};